(function () {
    'use strict';

    angular.module("imApp").factory("domObjectTypePropService", ['$ihttp', function ($ihttp) {
        let service = {
            getDomObjectTypeProp: function (parms) {
                return $ihttp.post({
                    method: 3022,
                    parameters: parms || {}
                });
            },
            listPropertyTypes: function (parms) {
                return $ihttp.post({
                    method: 3024,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3023,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 3025,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
